var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgElementWhyChooseVeracityAds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1800",
    style: {
      enableBackground: "new 0 0 1000 1800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0FC571;}\n\t.st1{fill:#33AAC6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e9c95aa7-9288-44c2-901e-3723676d208f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e1981dda-9309-41e5-ac06-64dddc7064c9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a0102269-6bcb-43c3-9dd3-b8031363188b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b889bf18-23ba-40e7-8a3d-086b9956554f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a0235dee-7195-4e3a-afe2-d7307e29b909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fbe99084-1fef-40ac-bdd8-ea7ef27246d0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,71v158.3c17.4,21,35.5,40.2,54.3,57.5c89.8,82.9,41.8,30,73.1,21.2s107.5-38.8,113.8-38.8 s103.3-112.9,103.3-112.9C204.4,8.8,75.7,33.3,0,71z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b01d560f-e78e-4c8e-81cb-7b63e41b0e4e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b34db9b0-119d-4852-8bde-4c5f90310b11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M718.3,1345.8c-17.7,0-41.3,10-116.5,94.8s-87,124.7-91.4,134.7c-4.4,10-278.6-37.4-2.9,177.1l1.6,1.2 c274.4,211.1,330.2-365.3,330.2-365.3S735.9,1345.8,718.3,1345.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bb0f1ad7-0b48-4202-ba4b-ef03660b84e9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7e1923d-6de3-4ca0-ae38-5aa2575be9c3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.9,100.5C184,248.1,67.1,250.4,0,222.9v1336.2c179.7,84,477.5,96.6,477.5,96.6 c582.5-64,520.6-922.6,520.6-922.6C944.2-372.4,371.9,100.5,371.9,100.5z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgElementWhyChooseVeracityAds);
export default __webpack_public_path__ + "static/media/bg-element-WhyChooseVeracityAds.60f1b515621e95c4bd4c9e2fd84ed3ac.svg";
export { ForwardRef as ReactComponent };